export enum SOCCER_LIST_TYPE {
  TEAM = '31',
  COMPETITION = '32',
}

export enum SOCCER_SECTION_ID {
  HOME_NAV = 500,
  HOME_HEADER = 505,
  SCORE = 405,
  STANDING = 410,
  COMPETITION = 415,
  CONTENT_BY_TEAMS_FOLLOWED = 420,
  MORE = 600,
}

export const bmAppWorldcupPageUrl =
  'baomoi://web?requiredLogin=true&shareSession=true&url=https%3A%2F%2Fwc.baomoi.com%2Flogin%3Futm_source%3DBMApp%26utm_medium%3Dzalodiscover%26utm_campaign%3Dwc22';

export const toBmAppWorldcupPageUrl =
  'https://baomoi.onelink.me/Dfp0?pid=Zalo&c=wc22_game&af_channel=zalo_discover&af_dp=baomoi%3A%2F%2Fweb%3Fsource%3Dwc22_native_zalodiscover%26requiredLogin%3Dtrue%26shareSession%3Dtrue%26url%3Dhttps%253A%252F%252Fwc.baomoi.com%252Flogin%253Futm_source%253DZalo%2526utm_medium%253DDiscoveryWidget%2526utm_campaign%253Dwc22&deep_link_value=baomoi%3A%2F%2Fweb%3Fsource%3Dwc22_native_zalodiscover%26requiredLogin%3Dtrue%26shareSession%3Dtrue%26url%3Dhttps%253A%252F%252Fwc.baomoi.com%252Flogin%253Futm_source%253DZalo%2526utm_medium%253DDiscoveryWidget%2526utm_campaign%253Dwc22';
